import { Form } from '@pinchenterprisesnpm/friday-ui'
import { Container } from 'styled-bootstrap-grid'
import styled from 'styled-components'

/** Bootstrap scrollable container for form fields. */
export const ContainerExtended = styled(Container)<{ $pt?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-top: ${({ $pt, theme: { mp } }) => $pt && mp.md};
`

/** Form wrapper that fills a PageSurface and supports a pinned FormFooter sibling. */
export const FormExtended = styled(Form)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`

/** Pinned action bar at the bottom of a form surface (e.g. Save button). */
export const FormFooter = styled.div`
  flex-shrink: 0;
  padding: ${({ theme: { mp } }) => `${mp.sm} ${mp.md} ${mp.md}`};
  display: flex;
  align-items: flex-end;
  border-top: 1px solid ${({ theme: { palette } }) => palette.light};
`

/**
 * Pinned action bar for multi-section forms without a `PageSurface` card.
 *
 * Avoid on new pages — use `FormFooter` inside `PageSurface $fill` instead.
 * Legacy usage: Add/Edit Template.
 */
export const FormFooter2 = styled.div`
  flex-shrink: 0;
  padding-top: ${({ theme: { mp } }) => mp.sm};
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
  align-items: flex-end;
`
